// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;

export const LOG_IN = 'Logged In';
export const LOG_OUT = 'Logged Out';